import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';

export default class extends Controller {
  connect(){
    this.updateTotals();
  }
  updateTotals(event) {
    let total = _.sumBy($(this.element).find('.or-total'), function(o) { return +$(o).val(); }); ;
    let grossweight = _.sumBy($(this.element).find('.or-gross-weight'), function(o) { return +$(o).val(); }); ;
    let netweight = _.sumBy($(this.element).find('.or-net-weight'), function(o) { return +$(o).val(); }); ;
    
    $(this.element).find('#operation-total').html(formatMoney(total));
    $(this.element).find('#operation-gross-weight').html(formatWeight(grossweight)+' gr');
    $(this.element).find('#operation-net-weight').html(formatWeight(netweight)+' gr');
    console.log('updateTotals', total, grossweight, netweight);
  }
  addRow(event) {
    let row = $(event.detail.row);
    let rowsTotal = _.sumBy($(this.element).find('.or-total'), function(o) { return +$(o).val(); }); ;
    let rowsQuantity = _.sumBy($(this.element).find('.or-quantity'), function(o) { return +$(o).val(); });
    let totalAmount = +$(this.element).find('#operation_total_amount').val();
    let totalGrossWeight = +$(this.element).find('#operation_total_gross_weight').val();

    let quantity = totalGrossWeight-rowsQuantity;
    if (quantity>0) {
      row.find('.or-quantity').val(quantity);
    }

    let total = totalAmount-rowsTotal;
    if (total>0) {
      row.find('.or-total').val(total);
    }
    console.log('addRow', );
  }
}
